<template>
  <div class="checkout-builder-image-modal">
    <h5>Selecione um ou dos dois dispositivos:</h5>
    <snow-checkbox-group
      v-model="form.config.display"
      :options="[
        { id: 'mobile', name: 'Versão para celular' },
        { id: 'desktop', name: 'Versão para computador' }
      ]"
    />

    <snow-input-file is-image is-fluid v-model="form.image" />

    <snow-select
      v-model="form.config.aspectRatio"
      id="aspect-ratio"
      label="Tamanho da imagem"
      :options="ratioOptions"
    />

    <div class="snow-submit-buttons mt-3">
      <snow-button
        size="lg"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        text="Inserir imagem"
        @click="save"
        :disabled="!isValid"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    position: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const aspectRatio = this.position == "side" ? "1" : "4.625";
    const component = {
      ...this.data,
      config: {
        aspectRatio,
        ...this.data.config,
        width: "100%",
        "object-fit": "cover"
      }
    };

    return {
      ...formFields(["image", "config"], {
        ...component,
        config: { display: ["desktop", "mobile"], ...component.config }
      }),
      ratioOptions: [
        { id: aspectRatio, name: "Ajustar às dimensões recomendadas" },
        { id: "unset", name: "Tamanho original" }
      ]
    };
  },
  computed: {
    isValid() {
      return this.form.image && this.form.config?.aspectRatio;
    }
  },
  methods: {
    save() {
      this.$emit("save", { ...this.data, type: "image", ...this.form });
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-image-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
  .bp-input-file .input-container {
    aspect-ratio: 2.7;
  }
}
</style>
